export const CLIENT_CARE_PATHWAYS = Object.freeze([
  Object.freeze({
    key: 'anissa_nutrition',
    label: 'Suivi nutrition avec Anissa',
    shortLabel: 'Anissa · Nutrition',
    description: 'Anissa pilote la nutrition. Aucun suivi sport régulier de Benoît n’est prévu.',
    sportCoordinationPlanned: false,
  }),
  Object.freeze({
    key: 'benoit_sport',
    label: 'Anissa + Benoît sport',
    shortLabel: 'Anissa · Benoît',
    description: 'Benoît suit la partie sport ; Anissa pilote la nutrition et prépare le relais si nécessaire.',
    sportCoordinationPlanned: true,
  }),
  Object.freeze({
    key: 'intact',
    label: 'Parcours INTACT',
    shortLabel: 'INTACT',
    description: 'Dossier coordonné entre nutrition et accompagnement sport dans le parcours INTACT.',
    sportCoordinationPlanned: true,
  }),
]);

const CLIENT_CARE_PATHWAY_BY_KEY = new Map(
  CLIENT_CARE_PATHWAYS.map((pathway) => [pathway.key, pathway]),
);

const UNKNOWN_CLIENT_CARE_PATHWAY = Object.freeze({
  key: null,
  label: 'Contexte non renseigné',
  shortLabel: 'À renseigner',
  description: 'Le contexte de prise en charge doit être confirmé par Anissa.',
  sportCoordinationPlanned: false,
});

export function isKnownClientCarePathway(value) {
  return typeof value === 'string' && CLIENT_CARE_PATHWAY_BY_KEY.has(value);
}

export function resolveClientCarePathway(valueOrForm) {
  const value = typeof valueOrForm === 'string'
    ? valueOrForm
    : valueOrForm?.carePathway;
  return CLIENT_CARE_PATHWAY_BY_KEY.get(value) || UNKNOWN_CLIENT_CARE_PATHWAY;
}

export function hasPlannedSportCoordination(valueOrForm) {
  return resolveClientCarePathway(valueOrForm).sportCoordinationPlanned === true;
}
